import * as React from "react";
//  import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import Header from "@tunnel-components/@sharded/header/index";
import Menu from "@tunnel-components/@sharded/menu/index";
import Modal from "@tunnel-components/@sharded/modal/segmentation/container";
import Inhibition from "@tunnel-components/@sharded/inhibitions/created";
import Loader from "@tunnel-components/@sharded/loader/component";
import Error from "@tunnel-components/@sharded/error/index";
import DetailsCamera from "@tunnel-components/@sharded/widgets/modal/details-camera/component";
import ModalRenitializationSequence from "@tunnel-components/@sharded/widgets/modal/initialization/component"; // à faire
import ModalWarningSequence from "@tunnel-components/@sharded/widgets/modal/warning/component";
import ModalInformationSequence from "@tunnel-components/@sharded/widgets/modal/infos/component";
import FilterRange from "@tunnel-components/@sharded/modal/filter-explorer/component";
// import FilterRange from '@tunnel-components/@sharded/modal/filter/index';
import FilterLapiTmd from "@tunnel-components/@sharded/modal/filter-lapi-tmd/component";
import ChangePassWord from "@tunnel-components/@sharded/modal/changepassword";
import ViewerImage from "@tunnel-components/@sharded/modal/images/component";
import AddNewUsers from "@tunnel-components/@sharded/modal/users/creation/component";
import UpdateUsers from "@tunnel-components/@sharded/modal/users/update/component";
import RemoveUsers from "@tunnel-components/@sharded/modal/users/remove/component";
import RemoveCamera from "@tunnel-components/@sharded/modal/camera/remove/component";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import SearchFinishIncidents from "@tunnel-components/@sharded/widgets/modal/search-incidents/component";
import ExploreIncidentItem from "@tunnel-components/@sharded/widgets/modal/explore-incident/component";
import LapiIncidentItem from "@tunnel-components/@sharded/widgets/modal/lapi/component";
import Deconnexion from "@tunnel-components/@sharded/widgets/modal/deconnexion/component";
import HealthCheck from "@tunnel-components/@sharded/healthCheck";

// import * as Lodash from "lodash";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    // onPlayBip,
    // incidenSound,

    arrayOfLapiIncident,
    explorerLapiData,
    onActiveOut,
    arrayOfIncident,
    onDeconnexion,
    deconnexion,
    onExtractImpact,
    onExtractVideo,
    onActive,
    // actionloading,
    rightdata,
    explorerData,
    onChangeItemPerRow,
    incidentPerRow,
    explorersearch,
    onExplorerSearch,
    onpensearchboolean,
    onPenSearchIncidents,
    placeholdersearch,
    onExplorerSearchChange,
    onSegmented,
    QualificationState,
    selectedValueName,
    dataUrlImage,
    viewSnapshotBoolean,
    editioncamerasuccees,
    cameraslapi,
    editioncameraerror,
    editionErrorIsDuplication,
    remouvecamera,
    onCloseCamera,
    suppressioncamerasuccees,
    suppressioncameraerror,
    onRemouveCamera,
    viewSnapshot,
    snackbarError,
    onGetValue,
    snackbar,
    someTextError,
    someTextSuccees,
    addUsersError,
    onCloseInhibitionModal,
    errorUpdateUser,
    roleError,
    nameError,
    firstnameError,
    loginError,
    someInputUpdateError,
    emailUpdateError,
    someInputError,
    emailError,
    onSearchQualification,
    qualification,
    onChangeUser,
    loginUserAdd,
    lapiFilter,
    onCloselapifilter,
    onDownloadLapiPdf,
    nameUserAdd,
    firstNameUserAdd,
    onChangeRoleUserAdd,
    emailUserAdd,
    roleUserAdd,
    onSubmitUser,
    isFilter,
    addUsers,
    onChangeRoleUser,
    onSubmitUpdateUser,
    removeUserObject,
    onChangeUpdateUser,
    userObject,
    updateUser,
    remouveuser,
    onUpdateUser,
    onRemouveUser,
    isOpenChangePwd,
    onOpenModal,
    onOpenAddUser,
    endDate,
    errorDateRange,
    onEndDateChange,
    startDate,
    onStartDateChange,
    sequenceReinitialization,
    onClose,
    onSearchSubmitFilter,
    sequenceWarning,
    sequenceInfos,
    section,
    cameras,
    label,
    loading,
    onSequence,
    onSequenceWarning,
    onSequenceReinitialization,
    onAllReinitialization,
    labelFilter,
    cameraFilter,
    sectionFilter,
    cameraSetting,
    segmentation,
    onSearchFilterCamera,
    onSearchFilterLabel,
    onSearchFilterSection,
    selectSection,
    cameraInformation,
    error,
    btnloading,
    inhibition,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  const CFG_NAMESPACE = "check";
  return (
    <StyledComponent.layoutAll>
      {/** Les boîtes  */}
      {/** Box incident */}{" "}
      {window[CFG_NAMESPACE].enabled && (
        <HealthCheck
          delay={window[CFG_NAMESPACE].CHECK_DELAY}
          timeout={window[CFG_NAMESPACE].CHECK_TIMEOUT}
        />
      )}
      {
        <ExploreIncidentItem
          arrayOfIncident={arrayOfIncident}
          onExtractImpact={onExtractImpact}
          onExtractVideo={onExtractVideo}
          onActive={onActive}
          // actionloading={!Lodash.isUndefined(actionloading[index]) && !!actionloading[index] && actionloading[index]}

          Elem={explorerData}
        />
      }
      {
        <LapiIncidentItem
          onActive={onActiveOut}
          Elem={explorerLapiData}
          onDownloadLapiPdf={onDownloadLapiPdf}
          arrayOfIncident={arrayOfLapiIncident}
        />
      }
      {/** Deconnexion */} <Deconnexion isOpen={deconnexion} />
      {/**  { /** selectedValueName={selectedValueName} onGetValue={onGetValue} errorDateRange={errorDateRange} cameras={cameras} cameraFilter={cameraFilter} onEndDateChange={onEndDateChange} startDate={startDate} onStartDateChange={onStartDateChange} onSearchSubmitFilter={onSearchSubmitFilter} */}
      {/** à grandir l'image */}{" "}
      <ViewerImage
        dataUrlImage={dataUrlImage}
        isVisible={viewSnapshotBoolean}
        onClose={viewSnapshot}
      />
      {/** Changement de mot de passe */}{" "}
      <ChangePassWord onOpenModal={onOpenModal} isVisible={isOpenChangePwd} />
      {/** Filtre pour la page lapi tmd  */}{" "}
      <FilterLapiTmd
        isOpen={lapiFilter}
        onClose={onCloselapifilter}
        cameras={cameraslapi}
        selectedValueName={selectedValueName}
        onGetValue={onGetValue}
        endDate={endDate}
        errorDateRange={errorDateRange}
        cameraFilter={cameraFilter}
        onSearchSubmitFilter={onSearchSubmitFilter}
        onEndDateChange={onEndDateChange}
        startDate={startDate}
        onStartDateChange={onStartDateChange}
      />
      {/** Filtre pour la page explorer  */}
      <FilterRange
        selectedValueName={selectedValueName}
        onGetValue={onGetValue}
        errorDateRange={errorDateRange}
        isOpen={isFilter}
        onClose={onClose}
        section={section}
        cameras={cameras}
        label={label}
        cameraFilter={cameraFilter}
        sectionFilter={sectionFilter}
        labelFilter={labelFilter}
        onSearchFilterCamera={onSearchFilterCamera}
        QualificationState={QualificationState}
        onSearchQualification={onSearchQualification}
        qualification={qualification}
        onSearchFilterLabel={onSearchFilterLabel}
        onSearchFilterSection={onSearchFilterSection}
        onSearchSubmitFilter={onSearchSubmitFilter}
        endDate={endDate}
        onEndDateChange={onEndDateChange}
        startDate={startDate}
        onStartDateChange={onStartDateChange}
      />
      {/** Segmentation  */}
      {segmentation && (
        <Modal
          isOpen={segmentation}
          onClose={onSegmented}
          selectSection={selectSection}
        />
      )}
      {/** Animation de chargement  */}
      {loading && !error && <Loader class={true} />}
      {/** modale de recherche des incidents */}{" "}
      <SearchFinishIncidents
        isVisible={onpensearchboolean}
        onPenSearchIncidents={onPenSearchIncidents}
        placeholdersearch={placeholdersearch}
        explorersearch={explorersearch}
        onExplorerSearch={onExplorerSearch}
        onExplorerSearchChange={onExplorerSearchChange}
      />
      {/** Chargement  */}
      {btnloading && <Loader class={true} />}
      {/** Création des inhibitions */}{" "}
      {inhibition && (
        <Inhibition isVisible={inhibition} onClose={onCloseInhibitionModal} />
      )}
      {/** Erreur serveur ( 500) */}
      {error && !loading && <Error />}
      {/** Détail de la camera */}
      <DetailsCamera
        isOpen={cameraSetting}
        camera={cameraInformation}
        editioncamerasuccees={editioncamerasuccees}
        editioncameraerror={editioncameraerror}
        editionErrorIsDuplication={editionErrorIsDuplication}
      />
      {/** Informations  */}{" "}
      <ModalWarningSequence
        isOpen={sequenceWarning && !error}
        toggleModal={onSequenceWarning}
      />
      {/** Informations  */}
      <ModalInformationSequence
        isOpen={sequenceInfos && !error}
        toggleModal={onSequence}
      />
      {/** Informations ( rénitialisation des masques) */}{" "}
      <ModalRenitializationSequence
        isOpen={sequenceReinitialization && !error}
        toggleModal={onSequenceReinitialization}
        onAllReinitialization={onAllReinitialization}
      />
      {/** Ajout d'utilisateur */}{" "}
      <AddNewUsers
        isVisible={addUsers}
        someInputError={someInputError}
        addUsersError={addUsersError}
        emailError={emailError}
        roleError={roleError}
        nameError={nameError}
        firstnameError={firstnameError}
        loginError={loginError}
        loginUserAdd={loginUserAdd}
        nameUserAdd={nameUserAdd}
        firstNameUserAdd={firstNameUserAdd}
        rightdata={rightdata}
        emailUserAdd={emailUserAdd}
        roleUserAdd={roleUserAdd}
        onChangeRoleUserAdd={onChangeRoleUserAdd}
        onOpenModal={onOpenAddUser}
        onChangeUser={onChangeUser}
        onSubmitUser={onSubmitUser}
      />
      {/** Modification d'utilisateur */}
      <UpdateUsers
        isVisible={updateUser}
        rightdata={rightdata}
        errorUpdateUser={errorUpdateUser}
        someInputUpdateError={someInputUpdateError}
        emailUpdateError={emailUpdateError}
        nameError={nameError}
        firstnameError={firstnameError}
        onOpenModal={onUpdateUser}
        userObject={userObject}
        onSubmit={onSubmitUpdateUser}
        onChange={onChangeUpdateUser}
        onChangeRoleUser={onChangeRoleUser}
      />
      {/**  Suppression d'utilisateur */}
      <RemoveUsers
        isVisible={remouveuser}
        onOpenModal={onRemouveUser}
        userObject={userObject}
        removeUser={removeUserObject}
      />
      {/**  Suppression d'une caméra */}
      <RemoveCamera
        isVisible={remouvecamera}
        suppressioncamerasuccees={suppressioncamerasuccees}
        suppressioncameraerror={suppressioncameraerror}
        camera={cameraInformation}
        onClose={onCloseCamera}
        removeCamera={onRemouveCamera}
      />
      {/**  */}
      <div className="header-tunnel">
        <Header
          {...props}
          onOpenModal={onOpenModal}
          onDeconnexion={onDeconnexion}
        />{" "}
        {/** Rendu de l'entête */}
      </div>
      <main className="wrapper">
        <section className="left menu menuRight " id="menu">
          <Menu
            onChangeItemPerRow={onChangeItemPerRow}
            incidentPerRow={incidentPerRow}
          />{" "}
          {/** Rendu du menu */}
        </section>
        <section className="left main mainRight" id="main">
          <div className="full-width-content" id="fullWidthContent">
            {/** Rendu du Contenu du site  <section className="tunnel-site"></section> */}
            <div style={{ height: "100%", width: "100%" }}>
              {props.children}
            </div>
            <SnackBar
              style={{ backgroundColor: "#00E1B3" }}
              isVisible={snackbar}
              someTextSuccees={someTextSuccees}
            />
            <SnackBar
              style={{ backgroundColor: "#ed5b56" }}
              isVisible={snackbarError}
              someTextSuccees={someTextError}
            />
          </div>
        </section>
      </main>
    </StyledComponent.layoutAll>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onUpdateUser?: any;
  onRemouveUser?: any;
  onOpenAddUser?: any;
  onOpenAddUsersModal?: any;
  addUsers?: boolean;
  children?: any;
  onSegmented?: any;
  isFilter?: any;
  endDate?: any;
  errorDateRange?: any;
  onEndDateChange?: any;
  startDate?: any;
  onStartDateChange?: any;
  sequenceReinitialization?: any;
  onClose?: any;
  onSearchSubmitFilter?: any;
  sequenceWarning?: any;
  sequenceInfos?: any;
  section?: any;
  cameras?: any;
  label?: any;
  loading?: any;
  onSequence?: any;
  onSequenceWarning?: any;
  onSequenceReinitialization?: any;
  onAllReinitialization?: any;
  labelFilter?: any;
  cameraFilter?: any;
  sectionFilter?: any;
  cameraSetting?: any;
  segmentation?: any;
  onSearchFilterCamera?: any;
  onSearchFilterLabel?: any;
  onSearchFilterSection?: any;
  selectSection?: any;
  cameraInformation?: any;
  error?: any;
  btnloading?: any;
  inhibition?: any;
  isOpenChangePwd?: any;
  onOpenModal?: any;
  updateUser?: any;
  remouveuser?: boolean;
  userObject?: any;
  onSubmitUpdateUser?: any;
  onChangeUpdateUser?: any;
  removeUserObject?: any;
  onChangeRoleUser?: any;
  onChangeUser?: any;
  onSubmitUser?: any;
  nameUserAdd?: any;
  firstNameUserAdd?: any;
  emailUserAdd?: any;
  roleUserAdd?: any;
  onChangeRoleUserAdd?: any;
  loginUserAdd?: any;
  QualificationState?: any;
  onSearchQualification?: any;
  qualification?: any;
  someInputError?: any;
  emailError?: any;
  someInputUpdateError?: any;
  emailUpdateError?: any;
  errorUpdateUser?: boolean;
  onCloseInhibitionModal?: any;
  addUsersError?: any;
  someTextError?: any;
  someTextSuccees?: any;
  snackbar?: any;
  snackbarError?: any;
  roleError?: any;
  nameError?: any;
  firstnameError?: any;
  loginError?: any;
  onGetValue?: any;
  viewSnapshotBoolean?: boolean;
  viewSnapshot?: any;
  onPlayBip?: any;
  dataUrlImage?: any;
  selectedValueName?: any;
  remouvecamera?: boolean;
  onCloseCamera?: any;
  onDownloadLapiPdf?: any;
  onRemouveCamera?: any;
  suppressioncamerasuccees?: boolean;
  suppressioncameraerror?: boolean;
  editioncamerasuccees?: boolean;
  editioncameraerror?: boolean;
  editionErrorIsDuplication?: boolean;
  explorersearch?: any;
  onExplorerSearch?: any;
  onExplorerSearchChange?: any;
  onpensearchboolean?: boolean;
  onPenSearchIncidents?: any;
  onChangeItemPerRow?: any;
  incidentPerRow?: any;
  placeholdersearch?: any;
  //
  arrayOfIncident?: any;
  onExtractImpact?: any;
  onExtractVideo?: any;
  onActive?: any;
  explorerData?: any;
  actionloading?: any;
  cameraslapi?: any;

  deconnexion?: boolean;
  onDeconnexion?: any;
  rightdata?: any;
  arrayOfLapiIncident?: any;
  explorerLapiData?: any;
  onActiveOut?: any;
  incidenSound?: boolean;
  lapiFilter?: boolean;
  onCloselapifilter?: boolean;
}

/** @export HOC pure */
// export default pure(Component);
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/layouts/layout/component.tsx